"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultStatusReason = void 0;
var DefaultStatusReason;
(function (DefaultStatusReason) {
    DefaultStatusReason[DefaultStatusReason["PendingCmhcReview"] = 100] = "PendingCmhcReview";
    DefaultStatusReason[DefaultStatusReason["PendingLenderInput"] = 200] = "PendingLenderInput";
    DefaultStatusReason[DefaultStatusReason["Approved"] = 300] = "Approved";
    DefaultStatusReason[DefaultStatusReason["ApprovedWithModifications"] = 400] = "ApprovedWithModifications";
    DefaultStatusReason[DefaultStatusReason["Cancelled"] = 500] = "Cancelled";
    DefaultStatusReason[DefaultStatusReason["NoLongerRequiredLoanRedeemed"] = 501] = "NoLongerRequiredLoanRedeemed";
    DefaultStatusReason[DefaultStatusReason["NoLongerRequiredStartOfEnforcement"] = 502] = "NoLongerRequiredStartOfEnforcement";
    DefaultStatusReason[DefaultStatusReason["InputError"] = 503] = "InputError";
    DefaultStatusReason[DefaultStatusReason["LoanPaidInFull"] = 504] = "LoanPaidInFull";
    DefaultStatusReason[DefaultStatusReason["PerLenderRequest"] = 505] = "PerLenderRequest";
    DefaultStatusReason[DefaultStatusReason["Inactive"] = 600] = "Inactive";
    DefaultStatusReason[DefaultStatusReason["InReview"] = 700] = "InReview";
    DefaultStatusReason[DefaultStatusReason["Declined"] = 800] = "Declined";
})(DefaultStatusReason = exports.DefaultStatusReason || (exports.DefaultStatusReason = {}));
